export default {
    "company_header": "Unternehmensdetails",
    "header_product_warning": "Registrieren Sie sich für das richtige GrabCAD-Produkt? Für {0} registrieren",
    "label": {
        "first_name": "Vorname",
        "last_name": "Nachname",
        "name": "Name",
        "company_name": "Name des Unternehmens",
        "university_name": "Name der Schule",
        "role": "Rolle",
        "company_size": "Größe des Unternehmens",
        "phone_number": "Telefonnummer",
        "printer": "Besitzen Sie einen 3D-Drucker?",
        "student_printer": "Besitzt Ihre Schule einen 3D-Drucker?",
        "uses_printer_for": "Wofür verwenden Sie Ihren 3D-Drucker?",
        "shop_owner": "Sind Sie für die Verwaltung Ihrer Modellwerkstatt verantwortlich?",
        "shop_users_expected": "Wie viele Personen reichen Bestellungen in Ihrer Werkstatt ein?",
        "email": "E-Mail",
        "email_confirm": "E-Mail bestätigen",
        "email_again": "E-Mail erneut eingeben",
        "password": "Passwort",
        "country": "Verwendet in",
				"state": "Bundesland/Region",
        "password_confirm": "Passwort bestätigen",
        "password_again": "Passwort erneut eingeben",
        "password_hint": "Mindestens 6 Zeichen",
        "interested_in": "Ich bin mehr interessiert an...",
        "industry_vertical": "Vertikale Branche",
        "industry_level": "Stellenebene",
        "business_email": "Büro-E-Mail",
        "business_email_confirm": "Büro-E-Mail bestätigen",
        "recaptcha": "Verifizieren Sie, dass Sie kein Roboter sind",
        "industry_level_select": "Jobebene auswählen",
        "company_size_select": "Größe auswählen",
        "industry_vertical_select": "Vertikale Branche auswählen"
    },
    "placeholders": {
        "name": "z. B. Johann Schmidt",
        "first": "Vorname",
        "last": "Nachname",
        "email": "E-Mail eingeben",
        "email_confirm": "E-Mail erneut eingeben",
        "password": "Passwort eingeben",
        "company_name": "Name des Unternehmens eingeben",
        "university_name": "Name der Schule eingeben",
        "phone_number": "Telefonnummer eingeben",
        "printer": "Antwort auswählen",
        "country": "Land auswählen",
				"state": "Bundesland oder Region auswählen",
        "business_email": "Büro-E-Mail eingeben",
        "business_email_confirm": "Büro-E-Mail bestätigen"
    },
    "terms": {
        "buy_now_text": "Durch Klicken auf „Weiter“ bestätigen Sie, dass Sie unsere",
        "workbench_text": "Durch Klicken auf „Für Workbench registrieren“ bestätigen Sie, dass Sie unsere",
        "print_text": "Durch Klicken auf „Registrieren“ bestätigen Sie, dass Sie unsere",
        "text": "Durch Klicken auf „Für Community registrieren“ bestätigen Sie, dass Sie unsere",
        "link": "Servicebedingungen"
    },
	"software_terms": {
		"link": "Bedingungen für die Software"
	},
    "privacy_policy": {
        "and": "und",
        "link": "Datenschutzrichtlinien",
        "text": "gelesen haben, diese akzeptieren und sich dazu verpflichten, sie einzuhalten."
    },
    "actions": {
        "next": "Weiter",
        "workbench_sign_up": "Für Workbench registrieren",
        "sign_up_button": "Registrieren",
        "shop_sign_up": "Kostenlose Evaluierung von GrabCAD Shop anfordern",
        "sign_up": "Für Community registrieren",
        "cancel": "Abbrechen"
    },
    "error": {
        "name_empty": "Fügen Sie bitte Ihren Namen hinzu",
        "email_taken": "Diese E-Mail-Adresse ist bereits registriert. Melden Sie sich an oder wählen Sie eine andere E-Mail-Adresse.",
        "email_empty": "Fügen Sie bitte Ihre E-Mail-Adresse hinzu",
        "email_nomatch": "Die E-Mail-Adressen müssen übereinstimmen",
        "email_look": "Bitte geben Sie eine gültige E-Mail-Adresse ein",
        "password_nomatch": "Die Passwörter müssen übereinstimmen",
        "password_short": "Das Passwort ist zu kurz. Es sollte mindestens 6 Zeichen lang sein.",
        "password_empty": "Bitte geben Sie Ihr Passwort ein",
        "recaptcha": "Klicken Sie auf das Kontrollkästchen, um zu verifizieren, dass Sie kein Roboter sind",
        "country_blocked": "Leider dürfen Sie sich nicht für GrabCAD registrieren",
        "blank": "darf nicht leer sein"
    },
    "active": {
        "email": "Geben Sie bitte Ihre echte E-Mail-Adresse ein, an die wir dann den Link für die Kontobestätigung senden."
    },
    "own_printer": {
        "default": {
            "no_dont_plan": "Nein, und ich plane dies auch nicht",
            "no_but_interesed": "Nein, aber ich bin interessiert",
            "yes_for_work": "Ja, für die Arbeit",
            "yes_as_hobby": "Ja, nur als Hobby",
            "yes_for_other": "Ja, aus anderen Gründen"
        },
        "student": {
            "no_dont_plan": "Nein, meine Schule ist nicht an 3D-Drucken interessiert",
            "no_but_interesed": "Nein, aber meine Schule ist derzeit auf der Suche nach einem 3D-Drucker",
            "yes_they_do": "Ja",
            "not_sure": "Nicht sicher"
        }
    },
    "uses_printer_for": {
        "professional": "Professionelle Anwendung",
        "education": "Ausbildung/Forschung",
        "hobby": "Hobby",
        "dont_use": "Ich benutze keinen 3D-Drucker"
    },
    "level_values": {
        "administrator_principal_superintendent": "Administrator",
        "biomedical_engineer": "Biomedizinscher Techniker",
        "c_level_executive": "C-Level",
        "clinical_preclinical": "Klinisch / Präklinisch",
        "dean_department_head": "Dekan",
        "dentist": "Zahnarzt",
        "designer": "Designer",
        "educator": "Ausbilder",
        "engineer": "Ingenieur",
        "equipment_manufacturer": "Gerätehersteller",
        "lab_owner": "Laborinhaber",
        "lab_technician": "Labortechniker",
        "marketing": "Marketing",
        "medical_education_and_training": "Medizinische Ausbildung",
        "parent": "Elternteil",
        "practicing_physician": "Praktizierender Arzt",
        "president_provost": "Präsident",
        "prosthetist_orthotist": "Orthopädie-Techniker",
        "purchasing": "Einkäufer",
        "quality": "Qualitätsmanager",
        "rd_engineering": "R&D",
        "sales": "Vertrieb",
        "senior_management_administration": "Senior Management",
        "student": "Student",
        "training": "Ausbildung",
        "other": "Andere",
        "not_employed": "Nicht angestellt"
    },
    "industry_values": {
        "aerospace": "Luft- und Raumfahrt",
        "architecture": "Architektur",
        "arts_entertainment": "Kunst und Kultur",
        "automotive": "Automobile",
        "commercial_products": "Handelserzeugnisse",
        "consumer_electronics": "Unterhaltungselektronik",
        "consumer_goods": "Konsumgüter",
        "dental": "Zahnmedizin",
        "education": "Bildung",
        "engineering_consulting_service": "Ingenieurberatungsleistungen",
        "government_military": "Behörden/Militär",
        "industrial_equipment": "Industrieanlagen",
        "jewelry": "Schmuck",
        "medical_device": "Medizintechnik",
        "service_bureau": "Dienstleistungen",
        "toys": "Spielzeug",
        "reseller": "Wiederverkäufer",
        "other": "Sonstiges"
    },
    "company_size": {
        "0 - 100": "0 - 100",
        "100 - 500": "100 - 500",
        "500 - 1,000": "500 - 1,000",
        "1,000 - 2,500": "1,000 - 2,500",
        "2,500 - 5,000": "2,500 - 5,000",
        "5,000 - 10,000": "5,000 - 10,000",
        "10,000 - 15,000": "10,000 - 15,000",
        "15,000 - 20,000": "15,000 - 20,000",
        "20,000+": "20,000+",
        "not_company": "Kein Unternehmen"
    },
    "yes_no_values": {
        "yes": "Ja",
        "no": "Nein"
    }
}
